import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom'
import * as actions from '../../reducers/form';
import { journalTypesProps, journalSystemsProps } from '../../api/list'
import { addProjectJournal } from '../../api/journals'
import validateProps from '../../functions/validateProps'
import { enqueueSnackbar } from '../../reducers/notifier'
import SimpleAdd from '../../components/SimpleAdd'

const formName = 'JournalCablesAdd'
const arrProps = [
  {
    field: 'journalNumber', label: 'Номер журнала', type: 'text', textProps: { inputProps: { maxLength: 100 } },
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    field: 'title', label: 'Наименование', type: 'text', textProps: { inputProps: { maxLength: 255 } },
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    field: 'typeId', type: 'autoLoad', label: 'Тип журнала',
    textProps: {
      path: journalTypesProps.path + '?categoryCode=ELEC',
      meta: {
        field: 'typeId',
        value: 'id',
        labelFunc: (obj) => obj.gostRef
      }
    }
  },
  {
    field: 'systemId', type: 'autoLoad', label: 'Системы',
    textProps: {
      path: journalSystemsProps.path,
      meta: {
        field: 'systemId',
        value: 'id',
        labelFunc: (obj) => obj.code + ' ' + obj.name
      }
    }
  },
  {
    field: 'stage', type: 'autoArr', label: 'Стадия',
    textProps: {
      arr: [{ value: 'П', label: 'Проектная документация (для экспертизы)' },
      { value: 'Р', label: 'Рабочая документация (для строительства)' },
      { value: 'И', label: 'Исполнительная документация (фактически проложенные кабели)' },
      ]
    }
  }
]
export default function JournalCablesAdd() {
  const dispatch = useDispatch()
  const history = useHistory()
  const params = useParams()
  useEffect(() => {
    dispatch(actions.formInitialize({
      journalNumber: '',
      title: '',
      typeId: null,
      systemId: null,
      stage: null,
      errorValidate: { journalNumber: false, title: false }
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form

  const handleSave = (e) => {
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: {
        journalNumber: values.journalNumber,
        title: values.title,
        typeId: values.typeId,
        systemId: values.systemId,
        stage: values.stage,
      },
      url: addProjectJournal.path({ id: params.idProject }),
      method: addProjectJournal.type,
      history: history
    }, formName))
  };
  return (
    <div className='App-paper'>
      <form autoComplete="off" onSubmit={handleSave}>
        <div style={{ padding: '16px' }}>
          <SimpleAdd formName={formName} arr={arrProps} title='Добавить кабельный журнал' />
        </div>
        <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        <Button type="submit" color="primary">Сохранить</Button>
      </form>
    </div>
  );
}
